import React from 'react'
import ClientPosMapping from '../../client/ClientPosMapping'
import V3ProfileRouteShell from '../profile/V3ProfileRouteShell'

export default function V3ClientPosMappingPage() {
  return (
    <V3ProfileRouteShell>
      <ClientPosMapping />
    </V3ProfileRouteShell>
  )
}

